import React from 'react';

export const ArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.792893 14.2071C0.402369 13.8166 0.402369 13.1834 0.792893 12.7929L6.08579 7.5L0.792895 2.20711C0.402371 1.81658 0.402371 1.18342 0.792895 0.792893C1.18342 0.402369 1.81658 0.402369 2.20711 0.792894L8.20711 6.79289C8.59763 7.18342 8.59763 7.81658 8.20711 8.20711L2.20711 14.2071C1.81658 14.5976 1.18342 14.5976 0.792893 14.2071Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.5 16.084l-1.403 1.416-4.09-4.096-4.102 4.096-1.405-1.405 4.093-4.092-4.093-4.098 1.405-1.405 4.088 4.089 4.091-4.089 1.416 1.403-4.092 4.087 4.092 4.094z"
      />
    </svg>
  );
};
export const DashIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="currentColor" />
      <rect x="4" y="7.5" width="8" height="2" fill="#1B2142" />
    </svg>
  );
};
export const DefaultImage = () => {
  return (
    <svg viewBox="0 0 46 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.9444 18.3889C34.0615 18.3889 35.7778 16.6726 35.7778 14.5556C35.7778 12.4385 34.0615 10.7222 31.9444 10.7222C29.8274 10.7222 28.1111 12.4385 28.1111 14.5556C28.1111 16.6726 29.8274 18.3889 31.9444 18.3889Z"
        fill="currentColor"
      />
      <path
        d="M0 5.61111C0 2.78832 2.28832 0.5 5.11111 0.5H40.8889C43.7117 0.5 46 2.78832 46 5.61111V41.3889C46 44.2117 43.7117 46.5 40.8889 46.5H5.11111C2.28832 46.5 0 44.2117 0 41.3889V5.61111ZM40.8889 5.61111H5.11111V25.8496L13.737 18.9489C14.6703 18.2022 15.9965 18.2022 16.9299 18.9489L27.9215 27.7422L31.4153 24.2485C32.4133 23.2505 34.0314 23.2505 35.0294 24.2485L40.8889 30.108V5.61111ZM5.11111 41.3889H40.8889V37.3362L33.2223 29.6697L29.9183 32.9737C28.9975 33.8945 27.5316 33.9757 26.5148 33.1622L15.3334 24.2172L5.11111 32.395V41.3889Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29289 0.792893C7.68342 0.402369 8.31658 0.402369 8.70711 0.792893L12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711C12.3166 6.59763 11.6834 6.59763 11.2929 6.20711L9 3.91421V14.5C9 15.0523 8.55228 15.5 8 15.5C7.44772 15.5 7 15.0523 7 14.5V3.91421L4.70711 6.20711C4.31658 6.59763 3.68342 6.59763 3.29289 6.20711C2.90237 5.81658 2.90237 5.18342 3.29289 4.79289L7.29289 0.792893ZM1 15.5C1.55228 15.5 2 15.9477 2 16.5V18.5H14V16.5C14 15.9477 14.4477 15.5 15 15.5C15.5523 15.5 16 15.9477 16 16.5V18.5C16 19.6046 15.1046 20.5 14 20.5H2C0.895431 20.5 0 19.6046 0 18.5V16.5C0 15.9477 0.447715 15.5 1 15.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DownArrow = () => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.5L0.669873 0.5L9.33013 0.500001L5 6.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SquareCheckFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
      <path
        d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SquareCheckEmpty = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
      <path
        d="M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
    >
      <path
        d="M13 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      ></path>
      <path
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
